module.exports = __webpack_public_path__ + "img/fisrt_bg_full.26789245.png";